import { connect } from 'react-redux';
import Global from '../../../../../store/global-selectors';
import ShipFromDropdownRenderer from '../../../../../fulfillment-planner/ship-from/ship-from-dropdown-renderer';
import { clearRateViewerError } from '../../../../../store/rate-viewer/rate-viewer.actions';
import { RateViewerTypes } from '../../../../../enums/rate-viewer-types';
import { updateRateBrowserShipFromId } from '../../../../../store/rate-browser/rate-browser.actions';

export const mapStateToProps = (state, { selectedShipFromId, validation }) => {
  const shipFroms = (Global.selectSellerShipFroms(state) || []).map((shipFrom) => ({
    id: shipFrom.shipFromId,
    name: shipFrom.name,
    ...shipFrom,
  }));

  return {
    selectedShipFromId,
    shipFroms,
    validation,
    parentComponentName: 'RateBrowser',
  };
};

const mapDispatchToProps = (dispatch, { onChange }) => {
  const onAddShipFromSuccess = (shipFromId) => {
    dispatch(clearRateViewerError(RateViewerTypes.rateBrowser));
    dispatch(updateRateBrowserShipFromId(shipFromId));
  };

  return {
    onChange,
    onAddShipFromSuccess,
  };
};

export const ShipFromContainer = connect(mapStateToProps, mapDispatchToProps)(ShipFromDropdownRenderer);
